import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

import API, { showNetworkErrorToast } from "Utils/api";
import { getApiBearerToken } from "Utils/authTokens";
import { updateVdaAction } from ".";
// import { RootState } from "../..";

export const fetchPatchVdaAction = createAsyncThunk<
  void,
  {
    id: string;
    data: Partial<any>; // You may want to define a proper VdaAction type
    successMessage?: string;
  }
>(
  "vdaActions/fetchPatchVdaAction",
  async ({ id, data, successMessage }, thunkAPI) => {
    try {
      const token = getApiBearerToken();
      if (!token) {
        toast.error("Authentication required. Please log in again.");
        return Promise.reject(new Error("No authentication token found"));
      }

      const response = await API.patch(`vda_actions/${id}/`, data);
      thunkAPI.dispatch(updateVdaAction(response.data));

      if (successMessage) {
        toast.success(successMessage);
      }

      return response.data;
    } catch (error: any) {
      // The shared auth interceptor on `API` has already refreshed and retried once; a 401/403
      // that still reaches here is a session the user has to renew.
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        toast.error("Authentication expired. Please log in again.");
        return Promise.reject(new Error("Authentication expired"));
      }

      showNetworkErrorToast(error);
      return Promise.reject(error);
    }
  }
);
